import { RecipeComplexity } from '../../common';
import { PredefinedFilters, QueryParamsGroups, SearchGroups } from './urlFilters.types';

const getUniqueParamValues = (value: string) => {
  const values = value
    .split(',')
    .map((v) => v.trim())
    .filter((v) => v);
  const usedSimplifiedValues: string[] = [];
  return values.reduce<string[]>((collection, nextValue) => {
    const simplifiedValue = nextValue.toLowerCase();

    if (!usedSimplifiedValues.includes(simplifiedValue)) {
      usedSimplifiedValues.push(simplifiedValue);
      collection.push(nextValue);
    }

    return collection;
  }, []);
};

export const deserializeUrlParams = (searchGroups: SearchGroups, predefinedFilters: PredefinedFilters) => {
  const result: QueryParamsGroups = {
    complexities: [],
    categories: [],
    texts: [],
  };
  const { complexities: complexitiesParam, categories: categoriesParam, texts: textsParam } = searchGroups;

  if (complexitiesParam) {
    const complexities = getUniqueParamValues(complexitiesParam);
    complexities.forEach((complexityName) => {
      const simplifiedValue = complexityName.toLowerCase();
      if (predefinedFilters.complexities.has(simplifiedValue)) {
        result.complexities.push(predefinedFilters.complexities.get(simplifiedValue) as RecipeComplexity);
      }
    });
  }

  if (categoriesParam) {
    const categories = getUniqueParamValues(categoriesParam);
    categories.forEach((categoryName) => {
      const simplifiedValue = categoryName.toLowerCase();
      if (predefinedFilters.categories.has(simplifiedValue)) {
        result.categories.push(predefinedFilters.categories.get(simplifiedValue) as string);
      }
    });
  }

  if (textsParam) {
    result.texts = getUniqueParamValues(textsParam);
  }

  return result;
};
